export default __webpack_public_path__ + "static/media/4.dc55e5e5.jpg";